export default "__VITE_ASSET__BJai6qhN__"